<template>
    <nav id="nav">
        <router-link to="/" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Home</router-link>
        <router-link to="/gastgeber" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Die Gastgeber</router-link>
        <router-link to="/zimmer" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Unsere Zimmer</router-link>
        <router-link to="/anfahrt" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Anfahrt</router-link>
        <router-link to="/preise" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Preise</router-link>
        <router-link to="/kultur" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Kultur</router-link>
        <router-link to="/kontakt" v-on:click.native="toggle()" v-bind:class="{expand: expand}">Kontakt</router-link>
    </nav>
</template>

<script>
    export default {
        name: "TheNavigation",
        data: () => { return {
                expand: false
            }},
        methods: {
            toggle() {
                if (this.$mq === 'mobile' || this.$mq === 'tablet') {
                    this.expand = !this.expand;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
#nav {
    font-size: 1.1em;
    display: flex;
    background: #333333;

    & a {
        color: #fff;
        padding: 14px 16px;
        text-decoration: none;
        border-right: 1px solid #dddddd;

        &.active-view {
            background: #32AC30;
        }

        &:hover:not(.active-view) {
            background: #282828;
        }
    }
}

/*
    mobile: 600,
    tablet: 900,
    laptop: 1200
    desktop: Infinity
 */
.tablet #nav, .mobile #nav {
    font-size: 1.0em;
    flex-direction: column;

    & a {
        border: none;
        opacity: 1.0;

        transition: height .2s, padding .3s, opacity .1s;

        &.active-view {
            &:not(.expand) {
                background: #333333;

                &::after {
                    content: "☰";
                    text-align: right;
                    float:right;
                }
            }
        }

        &:not(.active-view):not(.expand) {
            opacity: 0.0;
            height: 0;
            padding-top: 0;
            padding-bottom: 0;
        }
    }
}

</style>